import { CloseRounded, DeleteRounded } from "@mui/icons-material";
import { Box, Button, Dialog, Divider, IconButton, MenuItem, Select, Stack, Tab, Tabs, Typography } from "@mui/material";
import { grey, orange } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalState } from "context/GlobalContext";
import {
	cbChannelsizeQtyAssoc,
	channelTypes,
	colorBuyingChannelsAssoc,
	colorBuyTableColumns,
	regions,
	wearHouses,
} from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { useEffect, useState } from "react";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import HistoricalSizeRatioDataTable from "./HistoricalSizeRatioDataTable/HistoricalSizeRatioDataTable";
import { PimDashboardState } from "context/PimDashboardContext";
import { AuthState } from "context/AuthContext";
import { roundDecimalValueUptoTwo } from "utils/RoundDecimalValue";
import HistoricalDataTable from "./HistoricalDataTable/HistoricalDataTable";
import { generateBuyChannelRegionHistDataCacheKey } from "../../data";
import { BuyingDashboardState } from "context/BuyingDashboardContext";

const defaultSize = "Size";
const colStyle = {
	headerAlign: "center",
	align: "center",
	flex: 1,
};
const allSizes = ["S", "M", "L", "XL", "XXL", "XXXL"];

const preventMinus = (e) => {
	if (e.code === "Minus" || e.key === "+") {
		e.preventDefault();
	}
};
const CustomEditableCell = (props) => {
	const handleInputChange = (event) => {
		const newValue = event.target.value || 0;
		// Add your validation logic here
		// For example, to restrict input to numbers only:
		if (!isNaN(Number(newValue))) {
			props.api.setEditCellValue({
				id: props.id,
				field: props.field,
				value: newValue,
			});
		}
	};
	return (
		<div style={{ width: "100%", height: "100%" }}>
			<input
				value={props.value}
				onChange={handleInputChange}
				onKeyPress={preventMinus}
				min={0}
				style={{ width: "100%", height: "100%", border: "none", outline: "none" }}
			/>
		</div>
	);
};

const SizeRatioSection = ({
	tableRows,
	setTableRows,
	buyStaticData,
	sizeChangeCallback,
	selectedRegion,
	setDeletedSizesId,
	totalQty = 0,
}) => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	const { user } = AuthState();
	const { distinctSizeMaster } = PimDashboardState();
	console.log(distinctSizeMaster, "distinctSizeMaster");
	const [sizeToAdd, setSizeToAdd] = useState(defaultSize);

	const sizeTableColumns = [
		{
			field: "size",
			headerName: "Size",
			attribute_name: "",
			width: 120,
			...colStyle,
		},
		{
			field: "qty_percent",
			headerName: "Percentage %",
			attribute_name: "",
			width: 120,
			type: "number",
			// editable: channelTotalQty > 0,
			editable: true,
			...colStyle,
			renderEditCell: (params) => <CustomEditableCell {...params} />,
		},
		{
			field: "total_qty",
			headerName: "Qty",
			attribute_name: "",
			width: 120,
			// type: 'number',
			// editable: true,
			...colStyle,
			// renderEditCell: (params) => <CustomEditableCell {...params} />,
		},
		{
			field: "action",
			headerName: "Action",
			attribute_name: "",
			width: 120,
			...colStyle,
			renderCell: (params) => {
				return (
					<IconButton onClick={(e) => deleteSizeClick(params.row, e)}>
						<DeleteRounded />
					</IconButton>
				);
			},
		},
	];

	const processRowUpdateSize = (newRow, original) => {
		let percent = newRow.qty_percent === "" ? 0 : Number(newRow.qty_percent);
		let totalNumber = Math.floor((percent * totalQty) / 100);

		let newUpdatedRow = {
			...newRow,
			qty_percent: percent,
			total_qty: totalNumber,
			last_updated_by: user.email,
		};
		if (!newUpdatedRow?.is_new) newUpdatedRow.is_updated = true;

		let newSizeArr =
			tableRows?.map((val) => {
				if (val.id === newRow.id) {
					return newUpdatedRow;
				} else return val;
			}) ?? [];
		setTableRows(newSizeArr);
		sizeChangeCallback(newSizeArr);
		return newUpdatedRow;
	};

	const handleAddSize = () => {
		let isPresent = tableRows?.filter((row) => row.size === sizeToAdd);

		if (isPresent.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Size already Added `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		let data = [
			...(tableRows?.length ? tableRows : []),
			{
				size: sizeToAdd,
				id: new Date().valueOf(),
				total_qty: 0,
				region_total_qty: totalQty,
				region: selectedRegion,
				qty_percent: 0,
				size_metadata_id: 0,
				channel_level_buying_id: 0,
				is_new: true,
				created_by: user.email,
				last_updated_by: user.email,
			},
		];
		setTableRows(data);
		sizeChangeCallback(data);
	};

	const deleteSizeClick = (size, e) => {
		e.stopPropagation();
		let deletedData = tableRows.filter((row) => row.id !== size.id);
		sizeChangeCallback(deletedData);
		if (!size?.is_new) {
			setDeletedSizesId((prev) => {
				if (prev?.length) return [...new Set([...prev, size.id])];
				else return [size?.id];
			});
		}
		setTableRows(deletedData);
	};

	return (
		<Box display="flex" justifyContent="space-between">
			<Box width="65%">
				<DataGrid
					rows={tableRows ? tableRows : []}
					columns={sizeTableColumns}
					sx={{
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
						"& .MuiDataGrid-footer": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					processRowUpdate={processRowUpdateSize}
					onProcessRowUpdateError={(error) => console.log(error)}
					// showCellVerticalBorder
					// onRowClick={(params, e) => setselectedChannelBuy(params.row)}
					// initialState={{
					// 	pagination: {
					// 		paginationModel: { pageSize: 30 },
					// 	},
					// }}
					disableRowSelectionOnClick
					// pageSizeOptions={[50, 100]}
					hideFooter={true}
				/>
			</Box>
			<Stack spacing={1} width="28%" border={`1px solid ${grey[300]}`} p={1}>
				<Typography variant="body1">Add Size</Typography>
				<Select
					size="small"
					fullWidth
					value={sizeToAdd?.size}
					onChange={(e) => setSizeToAdd(e.target.value)}
					MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}>
					{distinctSizeMaster
						?.filter((row) => row?.brand === buyStaticData?.brand && row?.category === buyStaticData?.category)
						?.map((row) => {
							return (
								<MenuItem key={row?.size} value={row?.size}>
									{row?.size}
								</MenuItem>
							);
						})}
				</Select>
				<Button sx={{ margin: "22px 10px 0 10px" }} variant="contained" onClick={handleAddSize}>
					Add
				</Button>
			</Stack>
		</Box>
	);
};
const EditBuyingQtyModal = ({
	modalOpen,
	handleModalClose,
	updatedBuyData,
	setUpdatedBuyData,
	currentBuyStaticData,
	dataSaveCallback = () => {},
}) => {
	const { user } = AuthState();
	const { setLoadingOpen, setSnackBarOpen, setSnackBar, snackBar } = GlobalState();
	const { getBuyingCache, setBuyingCache } = BuyingDashboardState();
	const defChannelBuy = {
		[cbChannelsizeQtyAssoc]: [],
		is_new: true,
		created_by: user.email,
		last_updated_by: user.email,
	};
	const [currentChannelBuy, setCurrentChannelBuy] = useState();
	const [regionLevRows, setRegionLevRows] = useState([]);
	const [channelLevelRows, setChannelLevelRows] = useState(
		updatedBuyData?.[colorBuyingChannelsAssoc] ? [...updatedBuyData?.[colorBuyingChannelsAssoc]] : []
	);
	const [deltetedSizesId, setDeletedSizesId] = useState([]);

	const [totalQty, setTotalQty] = useState({ qty: 0 });
	const [remainingQty, setRemainingQty] = useState(0);
	const [remainingPercentage, setRemainingPercentage] = useState(0);

	const [activeChannel, setActiveChannel] = useState(channelTypes.EBO.key);
	const [selectedRegion, setSelectedRegion] = useState(regions.NORTH.key);
	const [isUpdated, setIsUpdated] = useState(false);

	const [historicalData, setHistoricalData] = useState();
	const [historicalLoading, setHistoricalLoading] = useState(false);

	const historicalDataAPI = async (data) => {
		try {
			const res = await axios.get(
				`/api/color_buying/buying_hist_region_lev_size_qty?brand=${data?.brand}&sub_brand=${data.sub_brand}&category=${
					data?.category
				}&sub_category=${data?.sub_category}&color=${data?.color}&season=${data?.season}
							&mrp=${data?.suggested_mrp ? data?.suggested_mrp : 2999}
							`
			);
			return res.data.result;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
		}
	};

	const fetchHistoricalData = async () => {
		const cacheKey = generateBuyChannelRegionHistDataCacheKey(currentBuyStaticData);
		const cached = getBuyingCache(cacheKey);
		if (cached) {
			setHistoricalData(cached);
			console.log("loaded from cache");
			console.log(cached, "cache");
			return;
		}
		setHistoricalLoading(true);
		try {
			const res = await historicalDataAPI(currentBuyStaticData, activeChannel, selectedRegion);
			const result = res ?? [];
			console.log(result, "result_buy");
			setHistoricalData(result);
			setBuyingCache(cacheKey, result);
		} catch (err) {
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(err),
				severity: "error",
			});
			setSnackBarOpen(true);
		} finally {
			setHistoricalLoading(false);
		}
	};

	useEffect(() => {
		fetchHistoricalData();
	}, []);

	const handleChannelChange = (channel) => {
		setActiveChannel(channel);
	};

	const handleRegionChange = (region) => {
		setSelectedRegion(region);
	};

	useEffect(() => {
		const currentChBuy = channelLevelRows?.filter((row) => row?.channel === activeChannel);
		if (currentChBuy?.length) {
			setCurrentChannelBuy(currentChBuy[0]);
			const regionRows = currentChBuy[0][cbChannelsizeQtyAssoc]?.filter((row) => row?.region === selectedRegion);
			setRegionLevRows(regionRows);
			let totalQty = 0;
			if (regionRows[0]?.region_total_qty) totalQty = regionRows[0]?.region_total_qty;
			setTotalQty({ qty: totalQty });
		} else {
			setCurrentChannelBuy({ ...defChannelBuy, channel: activeChannel });
			setRegionLevRows([]);
			setTotalQty({ qty: 0 });
		}
	}, [activeChannel, selectedRegion]);

	useEffect(() => {
		calculateRemainingQtyAndPerent(regionLevRows);
	}, [totalQty, regionLevRows]);
	const calculateRemainingQtyAndPerent = (allSizes, total) => {
		let remainigQty = total ? total : +totalQty?.qty ?? 0;
		let remainigPercent = 100;
		allSizes?.forEach((row) => {
			remainigQty -= Number(row?.total_qty) ? row?.total_qty : 0;
			remainigPercent -= Number(row?.qty_percent) ? row?.qty_percent : 0;
		});
		setRemainingPercentage(roundDecimalValueUptoTwo(remainigPercent));
		setRemainingQty(remainigQty);
	};

	const sizeDataChangeCallback = (updatedSizes) => {
		setCurrentChannelBuy((prev) => {
			let currentRows = prev?.[cbChannelsizeQtyAssoc]?.filter((row) => row?.region === selectedRegion && !row?.is_new);
			setDeletedSizesId((prev) => {
				if (prev?.length)
					return [
						...new Set([
							...prev,
							...currentRows?.reduce((acc, currentRow) => {
								const isPresent = updatedSizes?.filter((row) => row.id === currentRow.id);
								if (isPresent.length) return acc;
								acc.push(currentRow?.id);
								return acc;
							}, []),
						]),
					];
				else
					return currentRows?.reduce((acc, currentRow) => {
						const isPresent = updatedSizes?.filter((row) => row.id === currentRow.id);
						if (isPresent.length) return acc;
						acc.push(currentRow?.id);
						return acc;
					}, []);
			});

			let res = {
				...prev,
				[cbChannelsizeQtyAssoc]: [
					...prev?.[cbChannelsizeQtyAssoc]?.filter((row) => row?.region !== selectedRegion),
					...updatedSizes,
				],
			};
			setChannelLevelRows((prevRows = []) => {
				const exists = prevRows.some((row) => row?.id === prev.id);
				if (exists) {
					return prevRows.map((row) => (row?.id === prev.id ? res : row));
				} else {
					return [...prevRows, res];
				}
			});
			setIsUpdated(true);
			return res;
		});
	};

	const handelUseSizeRatioClick = (rowData, totalQty) => {
		console.log(rowData, totalQty, "sadhgsdfsdj");
		let totalPercent = 0;
		let calculatedTotalQty = 0;
		let res = (rowData?.distinct_sizes ?? [])?.map((row, i) => {
			const percent =
				rowData["total"] > 0 && rowData[row] > 0
					? Math.floor(roundDecimalValueUptoTwo((rowData[row] / rowData["total"]) * 100))
					: 0;
			totalPercent += percent;
			const totalNumber = Math.floor((percent * totalQty) / 100);
			calculatedTotalQty += totalNumber;
			console.log(row, percent, totalNumber, "sadhgsdfsdj");

			return {
				id: new Date().valueOf() + i,
				size: row,
				qty_percent: percent,
				total_qty: totalNumber,
				region: selectedRegion,
				region_total_qty: totalQty ?? 0,
				channel_level_buying_id: 0,
				is_new: true,
				created_by: user.email,
				last_updated_by: user.email,
			};
		});

		let extra = Math.abs(totalPercent - 100);
		// console.log(first);
		if (totalPercent > 100) {
			res = res.map((row) => {
				if (row.qty_percent > extra)
					return {
						...row,
						qty_percent: row.qty_percent - extra,
					};
				else return row;
			});
		} else if (totalPercent < 100) {
			res = res.map((row, i) => {
				if (i === res.length - 1)
					return {
						...row,
						qty_percent: row.qty_percent + extra,
					};
				else return row;
			});
		}
		let extraQty = Math.abs(calculatedTotalQty - totalQty);
		// console.log(first);
		if (extraQty > 100) {
			res = res.map((row) => {
				if (row.total_qty > extra)
					return {
						...row,
						total_qty: row.total_qty - extra,
					};
				else return row;
			});
		} else if (extraQty < 100) {
			res = res.map((row, i) => {
				if (i === res.length - 1)
					return {
						...row,
						total_qty: row.total_qty + extra,
					};
				else return row;
			});
		}
		console.log(res, "jsdfndskbfkes");
		setRegionLevRows(res);
		sizeDataChangeCallback(res);
	};
	const handleTotalQtyChange = (totalQty) => {
		const res = regionLevRows?.map((row) => {
			let percent = row.qty_percent === "" ? 0 : Number(row.qty_percent);
			let totalNumber = Math.floor((percent * totalQty) / 100);

			let newUpdatedRow = {
				...row,
				qty_percent: percent,
				total_qty: totalNumber,
				region_total_qty: totalQty,
				last_updated_by: user.email,
			};
			if (!newUpdatedRow?.is_new) newUpdatedRow.is_updated = true;
			return newUpdatedRow;
		});
		setRegionLevRows(res);
		sizeDataChangeCallback(res);
	};
	const handleSaveClick = async () => {
		setLoadingOpen(true);

		let updatedChannels = [];

		let buy_total_qty = 0;
		// handling Size type updates
		const userEmail = user.email;

		const allChWithTotalQty = channelLevelRows?.map((row) => {
			let total = 0;
			row?.[cbChannelsizeQtyAssoc]?.forEach((row) => {
				total += row?.total_qty;
			});
			buy_total_qty += total;
			return { ...row, total_qty: total };
		});
		let body = {
			...updatedBuyData,
			total_qty: buy_total_qty,
			[colorBuyingChannelsAssoc]: allChWithTotalQty,
			sizeIdsToDelete: deltetedSizesId,
		};

		try {
			await axios.post("/api/color_buying/update_buy_channel_lev_data", body).then((res) => {
				dataSaveCallback(res.data.result);
				setChannelLevelRows(res.data.result);
				handleModalClose();
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Server Error for size types `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleCancelEditClick = () => {
		setChannelLevelRows(updatedBuyData?.[colorBuyingChannelsAssoc] ?? []);
		handleModalClose();
	};

	return (
		<Dialog
			maxWidth="lg"
			keepMounted={false}
			PaperProps={{ style: { padding: "10px 20px", minHeight: "92vh", boxSizing: "border-box" } }}
			fullWidth
			open={modalOpen}
			scroll="body">
			<Box width="100%" display="flex" alignItems="center" justifyContent="space-between" pb={1}>
				<Typography variant="h6">Edit Buy Qty</Typography>
				<IconButton aria-label="close" onClick={handleCancelEditClick}>
					<CloseRounded />
				</IconButton>
			</Box>
			<Stack spacing={1}>
				<HistoricalDataTable data={currentBuyStaticData} />
				<Box display="flex" columnGap="10px" alignItems="center">
					<Typography sx={{ width: "80px" }}>Channels</Typography>
					<Tabs
						textColor="inherit"
						variant="scrollable"
						value={activeChannel}
						onChange={(e, val) => handleChannelChange(val)}
						sx={{
							width: "100%",
							boxShadow: "inset 0 -1px 0 0 #E6ECF0",
							border: `1px solid ${grey[200]}`,
							// [`& .${tabsClasses.indicator}`]: {
							// 	backgroundColor: "white",
							// },
						}}>
						{Object.values(channelTypes)?.map((row) => {
							return <Tab label={row?.name} value={row.key}></Tab>;
						})}
					</Tabs>
				</Box>

				<Stack width="100%" spacing={1} boxSizing="border-box">
					{/* regions */}
					<Box display="flex" columnGap="10px" alignItems="center">
						<Typography sx={{ width: "80px" }}>Regions</Typography>
						<Tabs
							textColor="inherit"
							variant="scrollable"
							value={selectedRegion}
							onChange={(e, val) => handleRegionChange(val)}
							sx={{
								width: "100%",
								boxShadow: "inset 0 -1px 0 0 #E6ECF0",
								border: `1px solid ${grey[200]}`,
								// [`& .${tabsClasses.indicator}`]: {
								// 	backgroundColor: grey[600],
								// },
							}}>
							{Object.values(regions)?.map((row) => {
								return <Tab label={row?.name} value={row.key}></Tab>;
							})}
						</Tabs>
					</Box>

					<Box width="100%" display="flex" justifyContent="space-between" pt={1} alignItems="center">
						<Typography variant="h6" fontWeight={600}>
							Suggested Ratio
						</Typography>
						<Typography>
							{activeChannel} Total:{" "}
							<span style={{ fontWeight: "bold" }}>
								{currentChannelBuy?.[cbChannelsizeQtyAssoc]?.reduce((acc, row) => {
									acc += row?.total_qty;
									return acc;
								}, 0) ?? 0}
							</span>
						</Typography>
					</Box>

					<HistoricalSizeRatioDataTable
						handleActionClick={handelUseSizeRatioClick}
						manualTotalQty={totalQty}
						data={historicalData}
						dataLoading={historicalLoading}
						selectedChannel={activeChannel}
						selectedRegion={selectedRegion}
					/>

					<Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
						<RenderInputField
							width="30%"
							column={{ ...colorBuyTableColumns.final_mrp, name: "Total Qty", key: "qty" }}
							data={totalQty}
							setData={setTotalQty}
							onChangeCallBack={(e, total_qty) => handleTotalQtyChange(total_qty)}
						/>
						<Box display="flex" columnGap="10px">
							<Typography>
								Remaining Qty : <span style={{ fontWeight: "bold" }}>{remainingQty}</span>
							</Typography>
							<Typography>
								Remaining Percent : <span style={{ fontWeight: "bold" }}>{remainingPercentage}</span>{" "}
							</Typography>
						</Box>
					</Box>
					<Divider sx={{ mt: 1, mb: 1 }} />

					<SizeRatioSection
						tableRows={regionLevRows}
						setTableRows={setRegionLevRows}
						sizeChangeCallback={sizeDataChangeCallback}
						currentChannelBuy={currentChannelBuy}
						selectedRegion={selectedRegion}
						buyStaticData={currentBuyStaticData}
						setDeletedSizesId={setDeletedSizesId}
						totalQty={+totalQty?.qty ?? 0}
						remainigQty={remainingQty}
						remainigPercent={remainingPercentage}
					/>
				</Stack>
			</Stack>
			<Stack direction="row" columnGap={1} justifyContent="flex-end" pt={1}>
				<Box display="flex" columnGap={1}>
					<Button variant="outlined" autoFocus onClick={handleCancelEditClick}>
						Cancel Edit
					</Button>
					<Button variant="contained" autoFocus onClick={handleSaveClick} disabled={!isUpdated}>
						Save
					</Button>
				</Box>
			</Stack>
		</Dialog>
	);
};

export default EditBuyingQtyModal;
